<template>
  <div>
    <div class="full-header borderBottom">
      <div
        v-if="technicalWorkMessage"
        class="tech-message text-center body-2 py-3 px-4"
        ref="techMessage"
      >
        {{ technicalWorkMessage }}
      </div>

      <div class="header navbar">
        <!-- logo -->
        <router-link
          to="/"
          class="d-flex td-none"
        >
          <v-img
            class="logo"
            :src="require('@/assets/logo.png')"
          />

          <v-toolbar-title
            v-if="!isXs"
            class="toolbar-text accent--text"
          >
            Сервис учета информации<br />о научных работах
          </v-toolbar-title>

          <v-toolbar-title
            v-if="isXs"
            class="toolbar-text-mini accent--text d-flex align-center"
          >
            СУИоНР
          </v-toolbar-title>
        </router-link>
        <v-spacer></v-spacer>

        <div
          class="d-flex align-center"
          v-if="!isSmAndDown"
        >
          <div class="my-2">
            <v-btn
              :class="{ 'mr-2': !username }"
              icon
              title="Помощь"
              @click.stop="$emit('openHelpDialog')"
            >
              <v-icon class="uikit-icon help-circle" />
            </v-btn>
          </div>

          <!--          <div class="my-2 ml-2" v-if="username">
                      <v-btn
                        :class="{'mr-1': !username}"
                        icon title="Сервисы"
                        @click.stop="$emit('openHelpDialog')"
                      >
                        <v-icon class="uikit-icon grid-icon" />
                      </v-btn>
                    </div>-->

          <div
            class="pr-3"
            v-if="username"
          >
            <v-menu
              offset-y
              v-model="loginMenu"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="d-flex d-inline align-center ml-8 pl-0 show-login-menu"
                  :title="username"
                >
                  <div class="d-flex flex-column">
                    <div class="btn-text">{{ username }}</div>
                  </div>
                  <v-list-item-avatar
                    height="24"
                    width="24"
                    class="ml-2"
                    min-width="24"
                  >
                    <v-icon class="uikit-icon user size-24" />
                  </v-list-item-avatar>
                  <v-icon
                    class="uikit-icon chevron-down delay-03"
                    :class="loginMenu ? 'rotate-180' : 'r0'"
                  />
                </div>
              </template>

              <v-list>
                <v-list-item
                  dense
                  class="login-menu-item"
                >
                  <v-list-item-title class="lightGrey--text body-2 v-list-username">
                    <v-icon class="uikit-icon user size-20" />
                    <span class="ml-2">{{ username }}</span>
                  </v-list-item-title>
                </v-list-item>

                <v-divider />

                <v-btn
                  text
                  class="login-menu-item w-full justify-start"
                  @click="logout"
                >
                  <v-icon class="uikit-icon log-out size-20" />
                  <span class="ml-2 btn-text">Выйти</span>
                </v-btn>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div
          class="hamburger"
          :class="{ active: activeMenu }"
          @click="hamburgerClick"
          v-else
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <div
      class="mobile-menu"
      ref="mobileMenu"
      :class="{ active: activeMenu }"
      v-if="isSmAndDown"
    >
      <div class="mt-2">
        <MenuLinks
          :links="links"
          :isMobile="true"
          v-if="username"
        />

        <div class="my-2">
          <v-btn
            class="lightGrey--text px-3"
            text
            @click.stop="$emit('openHelpDialog')"
          >
            Помощь
          </v-btn>
        </div>

        <v-menu
          offset-y
          v-if="username"
        >
          <template #activator="{ on }">
            <v-btn
              text
              v-on="on"
              color="grey"
              class="px-3"
            >
              <span class="lightGrey--text">{{ username }}</span>
              <v-icon
                color="lightGrey"
                right
                >mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              dense
              @click="logout"
            >
              <v-list-item-title class="accent--text body-1 pointer"> Выйти </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuLinks from '@/components/ui/MenuLinks'

export default {
  props: {
    links: Array,
    isSmAndDown: Boolean,
    isXs: Boolean
  },

  components: {
    MenuLinks
  },

  async mounted() {
    this.onResize()
    //this.setTechnicalWorkMessage()
    //setInterval(() => this.setTechnicalWorkMessage(), 300000)

    window.addEventListener('resize', this.onResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },

  data: () => ({
    technicalWorkMessage: null,
    activeMenu: false,
    loginMenu: false
  }),

  computed: {
    ...mapGetters('user', ['username'])
  },

  methods: {
    async logout() {
      try {
        await this.$store.dispatch('user/logout')
        await this.$router.push('/login')
        this.activeMenu = false
      } catch (e) {
        console.log(e.status)
      }
    },

    onResize() {
      this.calcActiveMenuTop()
    },

    // setTechnicalWorkMessage() {
    //   axios.get(`/message.json?${Math.random()}`).then(response => {
    //     if (this.technicalWorkMessage !== response.data.message) {
    //       this.technicalWorkMessage = response.data.message
    //       setTimeout(() => {
    //         this.setTechMessageHeight()
    //         this.calcActiveMenuTop()
    //       }, 200)
    //     }
    //   })
    // },

    calcActiveMenuTop() {
      const techMessage = this.$refs.techMessage
      const mobileMenu = this.$refs.mobileMenu

      if (techMessage) {
        mobileMenu && (mobileMenu.style.top = techMessage.offsetHeight + 'px')
      } else {
        mobileMenu && (mobileMenu.style.top = 0)
      }
    },

    hamburgerClick() {
      this.activeMenu = !this.activeMenu
    }
  },

  watch: {
    $route() {
      this.activeMenu = false
    }
  }
}
</script>

<style lang="sass" scoped>
.show-login-menu::before
  background-color: transparent !important

.login-menu-item
  min-width: 150px
  margin: 0 !important
  border-radius: 1px !important

a.td-none
  text-decoration: none

.pointer
  cursor: pointer
  font-weight: 400 !important

.full-header
  position: fixed
  width: 100%
  z-index: 6

  &.borderBottom
    border-bottom: 1px solid var(--v-lightGrey1-base)

.tech-message
  width: 100%
  color: white
  background-color: var(--v-error-base)

.header
  display: flex
  width: 100%

  .lh-normal
    line-height: 1

  .lh-more
    line-height: 1.25

.logo
  max-width: 44px
  max-height: 44px
  margin-left: 16px
  margin-top: 8px
  margin-bottom: 8px

.toolbar-text
  line-height: 1.15
  padding-left: 10px
  padding-top: 9px
  font-size: 18px

.toolbar-text-mini
  line-height: 1.15
  padding-left: 10px
  font-size: 18px

.v-list-username
  font-weight: 400 !important

.hamburger
  cursor: pointer
  margin-top: 22px
  margin-right: 16px
  margin-left: 12px

  span
    display: block
    width: 25px
    height: 3px
    margin-bottom: 4px
    border-radius: 20px
    background-color: var(--v-lightGrey-base)
    transition: .2s

    &:last-child
      margin-bottom: 0

  &.active
    span:nth-child(1)
      transform: rotate(-45deg) translate(-5px, 5px)

    span:nth-child(2)
      opacity: 0

    span:nth-child(3)
      transform: rotate(45deg) translate(-5px, -5px)

.mobile-menu
  position: fixed
  top: 0
  left: -100%
  width: 100%
  height: 100%
  background-color: var(--v-background-base)
  padding: 65px 0 0 12px
  z-index: 5
  transition: left .2s ease 0s

  &.active
    left: 0

.navbar
  background: var(--v-whiteBlack-base)
  border-bottom: 1px solid var(--v-lightGrey1-base)
</style>
